import { Observable, of } from "rxjs";
import { switchMap, mergeMap, map, withLatestFrom, catchError } from "rxjs/operators";
import { fromFetch } from "rxjs/fetch";
import { Location } from "./location";
import { Geocoder } from "./geocoder";
import { median } from "./utils/median";
export class LinrefCoder extends Geocoder {
    _locations = {};
    constructor(inputField, config_opt) {
        super(inputField);
        const newConf = config_opt || {};
        this.configure(newConf);
    }
    get query$() {
        const query$ = this.inputSearch$(300).pipe(withLatestFrom(this.configuration$), switchMap(([searchTerm, configuration]) => {
            if (searchTerm.length < 1)
                return of([]);
            const filters = configuration.datasets.map((x) => `dataset eq '${x}'`).join(" or ");
            return fromFetch(`${configuration.host}${configuration.endpoint}?q=${searchTerm}&limit=10&filter=${filters}`, {
                headers: {
                    Accept: "application/json",
                    "x-api-key": configuration.apiKey,
                },
                credentials: "omit",
            }).pipe(mergeMap((response) => {
                return response.json();
            }), map((json) => {
                const res = [];
                for (const pos of json.value) {
                    const _geopos = Location.createFromLinrefCoder(pos);
                    res.push(_geopos);
                    this._locations[_geopos.locationId] = _geopos;
                }
                return LinrefCoder.upperQuartile(res);
            }), catchError(() => {
                console.error("LinrefCoder: error fetching or parsing data.");
                return of([]);
            }));
        }));
        return query$;
    }
    select(locationId) {
        return new Promise((resolve, reject) => {
            if (this._locations[locationId]) {
                resolve(this._locations[locationId]);
            }
            else {
                reject(Error("no location found for the given id"));
            }
        });
    }
    _getDefaultConfiguration() {
        return {
            name: "linrefcode",
            host: "https://api.infra3d.com/linrefcode/",
            endpoint: "kmpoints",
            datasets: ["mgb"],
            apiKey: "",
        };
    }
    static upperQuartile(locations) {
        const score_median = median(locations.map((x) => x.score));
        const locations_upper = locations.filter((x) => x.score > score_median);
        const score_upper_quartile = median(locations_upper.map((x) => x.score));
        const locations_upper_quartile = locations_upper.filter((x) => x.score >= score_upper_quartile);
        if (locations_upper_quartile.length > 0)
            return locations_upper_quartile;
        return locations;
    }
}
//# sourceMappingURL=linrefcoder.js.map